/**
 * Phone navigation split for the WebAppShell (de-slop FE-15, decision D7):
 * a labelled bottom bar with up to four primary destinations plus "More",
 * which opens a sheet with everything else (mentor surfaces, admin).
 * Profile is reached from the header account button, so it is never in
 * the bar or the sheet list. Pure so it can be unit-tested.
 */
export const PHONE_BAR_MAX_PRIMARY = 4;

/** Preferred bar order; anything else goes to the More sheet. */
const PHONE_BAR_PREFERRED = ['dashboard', 'chat', 'sessions', 'progress'];

export interface PhoneNavSplit<T extends { key: string }> {
  bar: T[];
  more: T[];
  moreAdmin: T[];
}

export function splitPhoneNav<T extends { key: string }>(
  navItems: T[],
  adminItems: T[],
): PhoneNavSplit<T> {
  const candidates = navItems.filter((item) => item.key !== 'profile');
  const preferred = PHONE_BAR_PREFERRED
    .map((key) => candidates.find((item) => item.key === key))
    .filter((item): item is T => Boolean(item));
  const bar = [...preferred];
  for (const item of candidates) {
    if (bar.length >= PHONE_BAR_MAX_PRIMARY) break;
    if (!bar.includes(item)) bar.push(item);
  }
  return {
    bar,
    more: candidates.filter((item) => !bar.includes(item)),
    moreAdmin: adminItems,
  };
}
